<template>
  <div class="search-word-padding">
    <div class="search-word-scroll">
      <div class="search-word-list">
        <div
          class="word-item"
          v-for="(item, index) in renderList"
          :key="index"
          @click="bindClick(index)"
        >
          <span class="iconfont icon-sousuo"></span>
          <div class="w-content">
            <span v-html="item.text"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    data: {
      type: Array,
      default: () => []
    },
    word: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      renderList: []
    }
  },
  watch: {
    data() {
      this.renderList = this.getRederList()
    }
  },
  created() {
    this.renderList = this.getRederList()
    console.log(this.renderList)
  },
  methods: {
    getRederList() {
      let list = this.data.map((item, index) => {
        let obj = {}
        let reg = RegExp(this.word, 'g')
        if (index == 0) {
          obj.text = item.text.replace(
            reg,
            '<span style="color:rgba(0, 205, 223, 1);">' + this.word + '</span>'
          )
        } else {
          obj.text = item.name.replace(
            reg,
            '<span style="color:rgba(0, 205, 223, 1);">' + this.word + '</span>'
          )
        }
        return obj
      })
      return list || []
    },
    bindClick(index) {
      this.$emit('search', this.data[index].name)
    }
  }
}
</script>
<style lang="scss" scoped>
.search-word-padding {
  color: rgba(0, 0, 0, 0.8);
  height: 100%;
  box-sizing: border-box;
  padding: 4px 16px;
}

.search-word-scroll {
  height: 100%;
  overflow-y: scroll;

  .search-word-list {
    font-size: 14px;
    line-height: 20px;

    .word-item {
      display: flex;
      align-items: center;
      padding: 12px 0px;
      border-bottom: 1px solid rgba(234, 234, 238, 0.39);

      .iconfont {
        font-size: 18px;
        color: #d1d1d3;
        margin-right: 8px;
      }

      .w-content {
        flex: 1;
        flex-shrink: 0;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
}
</style>
